<!-- TOP COMMON AREA -->
<div class="dashboard-cards-wrap mt-3 mb-4">
	<app-dashboard-metric-card
		card="operator.saphetyComission"
		[value]="saphetyComission | currencyLocale: CurrencyCode.Euro"
		[labelSuffix]="CurrentMonth?.toString()"
		[loading]="loadingSaphetyComission"
		[hasAction]="canNavigateToSovosCommissions"
		(action)="navigateToSovosCommissions()" />
	<app-dashboard-metric-card
		card="operator.totalBuyersWithActiveConfirmingContractsAndActiveFactoringConnections"
		[value]="totalBuyersWithActiveConfirmingContractsAndActiveFactoringConnections"
		[loading]="loadingTotalBuyersWithActiveConfirmingContractsAndActiveFactoringConnections" />
	<app-dashboard-metric-card
		card="operator.totalSuppliersWithActiveConfirmingConnectionsAndActiveFactoringContracts"
		[value]="totalSuppliersWithActiveConfirmingConnectionsAndActiveFactoringContracts"
		[loading]="loadingTotalSuppliersWithActiveConfirmingConnectionsAndActiveFactoringContracts" />
	<app-dashboard-metric-card
		card="operator.totalActiveConnections"
		[value]="totalActiveConnections"
		[loading]="loadingTotalActiveConnections" />
</div>

<!-- TABS -->
<eif-custom-tabs
	[tabs]="tabs"
	[activeTabId]="activeTabId"
	[actions]="tabActions"
	(tabChange)="onTabChange($event)"
	[class]="'mb-4'">
	<div class="dashboard-tab-content">
		<!-- CONFIRMING AREA -->
		@if (activeTabId === DASHBOARD_TAB_CONFIRMING) {
			<div>
				<!-- CURRENCIES -->
				@if (orderedCurrencies.length > 1) {
					<eif-custom-segmented-control
						[options]="currencyOptions"
						[value]="selectedCurrency"
						[class]="'mb-2'"
						[size]="'small'"
						[variant]="'outlined'"
						(valueChange)="clickedCurrency($event.toString())">
					</eif-custom-segmented-control>
				}
				<div class="dashboard-cards-wrap">
					<app-dashboard-metric-card
						card="confirming.contractedAmount"
						[value]="confirmingContractedAmount | currencyLocale: selectedCurrency"
						[loading]="loadingConfirmingContractedAmount" />
					<app-dashboard-metric-card
						card="confirming.contractsAvailableAmount"
						[value]="confirmingContractsAvailableAmount | currencyLocale: selectedCurrency"
						[sublabel]="((confirmingContractsAvailableAmountRatio | numberLocale: '1.2-2') ?? '0') + '%'"
						[loading]="loadingConfirmingContractsAvailableAmount" />
					<app-dashboard-metric-card
						card="confirming.notPaidDocuments"
						[value]="confirmingNotPaidDocuments | currencyLocale: selectedCurrency"
						[loading]="loadingConfirmingNotPaidDocuments" />
					<app-dashboard-metric-card
						card="confirming.approvedRequestFunds"
						[value]="confirmingApprovedRequestFunds | currencyLocale: selectedCurrency"
						[labelSuffix]="CurrentMonth?.toString()"
						[loading]="loadingConfirmingApprovedRequestFunds" />
					<app-dashboard-metric-card
						card="confirming.currentFundingRequestsAmount"
						[value]="confirmingCurrentFundingRequestsAmount | currencyLocale: selectedCurrency"
						[loading]="loadingConfirmingCurrentFundingRequestsAmount" />
					<app-dashboard-metric-card
						card="confirming.averageMonthFundingRequestDays"
						[value]="confirmingAverageMonthFundingRequestDays"
						[loading]="loadingConfirmingAverageMonthFundingRequestDays" />
					<app-dashboard-metric-card
						card="confirming.monthlyAutomaticPayments"
						[value]="confirmingMonthlyAutomaticPayments | currencyLocale: selectedCurrency"
						[labelSuffix]="CurrentMonth?.toString()"
						[loading]="loadingConfirmingMonthlyAutomaticPayments" />
					<app-dashboard-metric-card
						card="confirming.buyersCompaniesCount"
						[value]="confirmingBuyersWithActiveContractsCompaniesCount"
						[loading]="loadingConfirmingBuyersWithActiveContractsCompaniesCount" />
					<app-dashboard-metric-card
						card="confirming.suppliersCompaniesCount"
						[value]="confirmingSuppliersWithActiveConnectionsCompaniesCount"
						[loading]="loadingConfirmingSuppliersWithActiveConnectionsCompaniesCount" />
					<app-dashboard-metric-card
						card="confirming.suppliersActiveConnections"
						[value]="confirmingSuppliersActiveConnections"
						[loading]="loadingConfirmingSuppliersActiveConnections" />
					<app-dashboard-metric-card
						card="confirming.pendingApprovalDocumentsAmount"
						[value]="confirmingPendingApprovalDocumentsAmount"
						[loading]="loadingConfirmingPendingApprovalDocumentsAmount"
						(action)="navigateToFilesIntegration(FileStatus.PendingBuyerApproval)" />
				</div>
			</div>
		}
		<!-- FACTORING AREA -->
		@if (activeTabId === DASHBOARD_TAB_FACTORING) {
			<div>
				<app-dashboard-factoring-tab
					[currentMonth]="CurrentMonth"
					[canNavigate]="true" />
			</div>
		}
	</div>
</eif-custom-tabs>

